export default "__VITE_ASSET__DaSdidar__"